// reportDownload.ts · v12.10.12 (#1546 / #1550 Excel export) · 2026-10-10 · VoiceSpectrum AI
// POST a body and save the file the API answers with (the Excel export). The bearer token as every other call.
import { ApiError, buildUrl } from './api';

export async function postAndSave(path: string, body: unknown, fallbackName: string): Promise<void> {
  const token = localStorage.getItem('vs_t2_token');
  const res = await fetch(buildUrl(path.startsWith('/api') ? path : `/api${path}`), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}) },
    body: JSON.stringify(body),
    credentials: 'include',
  });
  if (!res.ok) throw new ApiError(res.status, `HTTP ${res.status}`, null);
  const blob = await res.blob();
  const cd = res.headers.get('Content-Disposition') ?? '';
  const m = /filename\*?=(?:UTF-8'')?"?([^";]+)"?/i.exec(cd);
  const name = m ? decodeURIComponent(m[1]) : fallbackName;
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url; a.download = name; document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 10_000);
}
